import { FaqEntryResp } from 'types/api/response/faq-entry-resp'
import { HelpCenterFaqEntryModel } from 'types/models/help-center'

export const transformFaqEntryResponse = ({
  faq_entry,
}: FaqEntryResp): HelpCenterFaqEntryModel | undefined => {
  if (!faq_entry) return undefined

  return {
    id: faq_entry.id,
    title: faq_entry.title,
    body: faq_entry.body,
  }
}
